import Vue from 'vue';
import { http } from '../../http';
import Apps from '../../../core/Apps';
import filter from "lodash/filter";

export default {
    state: {
        surveyRequests: [],
        loaded: false,
        loading: false,
        client_id : 0,
    },

    mutations: {
        setSurveyRequests(state, surveyRequests = null) {
            state.surveyRequests = surveyRequests || [];
        },
    },

    getters: {
        loading: (state, getters) => {
            return state.loading;
        },

        all: (state, getters) => {
            return filter(state.surveyRequests, (sr) => { return sr.client_id === state.client_id; });
        },

        isLoaded(state, getters) {
            return state.loaded;
        },
    },

    actions: {
        load ({ commit, state, rootGetters }, client_id) {

            //Don't reload if it is the same client that is requested
            if ((state.loaded && client_id === state.client_id) || state.loading) {
                return;
            }

            state.client_id = client_id;
            state.loading = true;

            if ( ! rootGetters['apps/isAppEnabled'](Apps.Surveys)) {
                state.loaded = true;
                state.loading = false;
                return;
            }

            http.get('/app/client/'+client_id+'/survey-requests')
                .then(({ data }) => {
                    commit('setSurveyRequests', data.surveyRequests);
                    state.loaded = true;
                    state.loading = false;
                }).catch(() => {
                    state.loading = false;
                });
        },

        reload({ state, dispatch }) {
            state.loaded = false;
            dispatch('load');
        },
    }
};
